import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/blocks/components/not-found-content/index.tsx");
